module.exports = __webpack_public_path__ + "img/avatar.ee4cd372.png";